import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';

import { styles } from './Info.scss';

const cx = classNames.bind(styles);

export const Info = ({ children, className, ...props }) => {
  const classes = cx('c-auth-info', className);

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

Info.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
};

Info.defaultProps = {
  className: '',
};
